export default "__VITE_ASSET__DnlwD_nJ__"